__turbopack_context__.v({
  "ctaPlaceholder": "page-module___8aEwW__ctaPlaceholder",
  "ctas": "page-module___8aEwW__ctas",
  "intro": "page-module___8aEwW__intro",
  "main": "page-module___8aEwW__main",
  "page": "page-module___8aEwW__page",
  "primary": "page-module___8aEwW__primary",
  "secondary": "page-module___8aEwW__secondary",
  "signedIn": "page-module___8aEwW__signedIn",
  "tagline": "page-module___8aEwW__tagline",
  "title": "page-module___8aEwW__title",
});
